import React, { useContext, useEffect, useState } from "react";

import PropertyCrudComp from './hoa-property-crud-comp';
import TableLayout from "../table-layout/hoa-table-layout";
import SuccessMessage from "../success-message/hoa-success-message";
import FilteringComponenet from "../filtering-component/hoa-filtering-comp";

import config from "../../hoa-config";
import datastore from "../../store/hoa-datastore";
import { GlobalContext } from "../../context/hoa-global-context";
import dashboardServices from '../../services/hoa-dashboard-api-service';
import useAbortController from '../../hooks/useAbortController';

import './hoa-property.scss';

export default function PropertyDashboard() {
	const { property, updateView, updateSelectedValues, view: views } = useContext<any>(GlobalContext);

	const signal = useAbortController()

	const [view, setView] = useState(views !== "view-more-details" ? "list" : 'view');
	const [success, setSuccess] = useState(false);
	const [message, setMessage] = useState("");

	const headers = config.dashboard["Properties"]?.tableLayout?.title;
	const columns = config.dashboard["Properties"]?.tableLayout?.columns;
	const filteringTitle = config.dashboard["Properties"]?.filterComponent?.title;
	const filteringSubTitle = config.dashboard["Properties"]?.filterComponent?.subTitle;

	const getProperties = async (numberOfProperties: number, pageNo: number) => {
		const { data } = await dashboardServices.getProperties(numberOfProperties, pageNo, property.options, datastore.selectedOrganization?.id, signal);
		return {
			data: data.properties,
			count: data.parseCount
		};
	};



	useEffect(() => {
        if (views === "add") {
			setMessage("Property Created Succesfully");
		} else if (views === "update") {
			setMessage("Property Updated Succesfully");
		} else if (views === 'back-to-list') {
            setView('list');
            updateView('list');
            return;
        } else if(views === 'remove-from-list') {
            setMessage("Property Removed Succesfully");
            setView('list');
            updateView('list');
            return;
        } else if(views === 'view-more-details'){
			setView('view');
			updateView('view');
			return;
		}
        updateView(view);
    },[view,views === 'back-to-list',views === 'remove-from-list',views === 'view-more-details']);

	return (
		<>
			{view === "list" ? (
				<>
					<FilteringComponenet
						onAddClick={setView}
						title={filteringTitle}
						subTitle={filteringSubTitle}
						tagType={"Property"}
					/>
					<TableLayout
						fetchResult={getProperties}
						headers={headers}
						columns={columns}
						tagType={"Property"}
						updateView={setView} 
						updateSelectedValues={updateSelectedValues}
					/>
				</>
			) : (
				<PropertyCrudComp setSuccess={setSuccess} view={view} setView={setView} />
			)}

			<SuccessMessage success={success} setSuccess={setSuccess} message={message} />
		</>
	);
}
